export default {
  POWERED_BY_MERINIO: `Powered by Merinio`,
  START_AT_THIS_LOCATION: `Launch the Punch Terminal at this location:`,
  LAUNCH_PUNCH_TERMINAL: `Lauch Punch Terminal`,
  GO_TO: `Go to terminal`,
  START_PUNCH_SESSION: `Punch Terminal`,
  INVALID_PUNCH_TERMINAL_TOKEN: 'Session invalide, veuillez contacter votre gestionnaire. / Invalid session, please contact your manager.',
  AUTH_PUNCH: 'Punch in/out',
  AUTH_EMPLOYEE_NUMBER: 'Employee number',
  AUTH_EMPLOYEE_ID: `Employee ID`,
  AUTH_CANNOT_FIND_EMPLOYEE_BY_EMPLOYEENUMBER: "Aucun employé avec ce numéro d'employé. / Cannot find an employee with this employee number.",
  AUTH_CANNOT_FIND_EMPLOYEE_BY_EMPLOYEEID: "Aucun employé avec ce numéro d'employé. / Cannot find an employee with this employee number.",
  INACTIVE_ARCHIVED_USER_CANT_LOGIN:
    "Les utilisateurs archivés, inactif, et terminé ne peuvent pas se connecter. / Inactive, archived, or terminated users can't login.",
  AUTH_NO_EMPLOYEE_NUMBER: "Vous devez spécifier un numéro d'employé. / You must enter an employee number.",
  UNSPECIFIED_ERROR_PLEASE_CHECK_CONNECTION:
    "An unknown error has occurred, please check your connection / Une erreur inconnue s'est produite, veuillez valider votre connexion",
  notification: {
    ARRIVAL_SAVED: `Arrival time saved`,
    ARRIVAL_SAVED_DESC: `{{userName}}, your <1>arrival time</1> was saved at <2>{{time}}</2>.`,
    ARRIVAL_INFO: `You arrived <0>{{delay}}</0> {{type}}!`,
    DEPARTURE_SAVED: `Departure time saved`,
    DEPARTURE_ALREADY_SAVED: `Departure time has already been saved`,
    DEPARTURE_SAVED_DESC: `{{userName}}, your <1>departure time</1> was saved at <2>{{time}}</2>. You have worked <3>{{workedHours}}</3>.`,
    DEPARTURE_INFO: `You left <0>{{delay}}</0> {{type}}!`,
    PUNCH_CREATED: `Punch card created`,
    NO_ARRIVAL_OR_DEPARTURE_SAVED: `A punch card was created but no arrival or departure was saved`,
    LOCATION_WARNING: `Your location does not correspond to the shift location`,
    NO_LOCATION_ACCESS: `Merinio does not have access to your location.`,
    TRANSFER_SAVED: `Transfer saved`,
    TRANSFER_SAVED_DESC: `{{userName}}, your <1>transfer time</1> was saved at <2>{{time}}</2>.`,
    BREAK_START_SAVED: `Break start saved`,
    BREAK_START_SAVED_DESC: `{{userName}}, your <1>break begining</1> was saved at <2>{{time}}</2>.`,
    BREAK_END_SAVED: `Break end saved`,
    BREAK_END_SAVED_DESC: `{{userName}}, your <1>break ending</1> was saved at <2>{{time}}</2>.`
  },
  DETECTED_SOME_PUNCH_ISSUES: {
    TITLE: `We've detected some issues`,
    SUMMARY: '',
    DESC: `You haven't punched out of some punch cards and we detected you might be trying to punch in right now.`,
    PUNCHED_IN_AT: `Punched in at <0>{{ time }}</0>`
  },
  YOU_HAVENT_PUNCH_OUT_THESE_SHIFT: `These shifts haven't been punched out of yet:`,
  PUNCH_OUT: `Punch out`,
  PUNCH_IN: `Punch in`,
  PUNCH_SEE_INFOS: `See the shift details`,
  LATE: `late`,
  EARLY: `early`,
  LOGOUT_RETURN_TO_TERMINAL: `Cancel`,
  NO_SHIFT_TO_PUNCH: `It looks like you have no shifts assigned to you today. Check with your manager to resolve this issue.`,
  PUNCH_IN_ANYWAY: `<0>Punch in</0> anyway`,
  PUNCH_OUT_ANYWAY: `<0>Punch out</0> anyway`,
  SHIFTS_ALREADY_PUNCHED: `Shifts already punched`,
  ALREADY_PUNCHED_IN_OUT: 'You have already punched out',
  SELECT_SHIFT_GREETING: `Hi <0>{{userName}}</0>, select your shift:`,
  DASHBOARD_GREETING: `Hi <0>{{userName}}</0>, here are the details for your shift.`,
  DASHBOARD_DESCRIPTION: `Below, you can punch in, go on a break and punch out when you're done with your shift.`,
  DASHBOARD_DONE_DESCRIPTION: `Your time for this shift has been recorded. Have a nice day!`,
  DASHBOARD_WORK_HOURS: 'Work hours',
  DASHBOARD_START_TIME: 'Start time',
  DASHBOARD_END_TIME: 'End time',
  DASHBOARD_ARRIVED_AT: 'Arrived at',
  DASHBOARD_LEFT_AT: 'Left at',
  DASHBOARD_TAKE_BREAK: 'Take a break',
  DASHBOARD_UNPLANNED_BREAK: 'Unplanned break',
  DASHBOARD_UNPLANNED_BREAK_DESCRIPTION: 'Go on an unplanned break',
  DASHBOARD_BREAK_BREAK_TAKEN: 'You took this break',
  DASHBOARD_NO_BREAKS: 'No breaks',
  DASHBOARD_YOU_PUNCHED_IN: 'You punched in !',
  DASHBOARD_YOU_PUNCHED_OUT: 'You punched out !',
  DASHBOARD_HAVE_A_NICE_DAY: 'Have a nice day!',
  DASHBOARD_DID_NOT_TAKE_BREAK: 'You did not take this break.',
  DASHBOARD_SHIFT_INFO: 'Shift',
  DASHBOARD_BACK_TO_PUNCH: 'Return to punch terminal',
  NO_ASSOCIATED_SHIFT: 'No associated shift',
  POSITION: `Position`,
  PROJECT: `Project`,
  COMMENT: `Comment`,
  TRANSFER_TIME: `Transfer time`,
  TRANSFER_TO_POSITION: 'Transfer to this position',
  TRANSFER_TO_PROJECT: 'Transfer to this project',
  START_TRANSFER: 'Start transfer',
  TRANSFER: 'transferred',
  SELECT_POSITION: 'Select position',
  TRANSFERED_TO: 'transfered to',
  TRANSFERS: 'Transfers',
  BREAKS: `Breaks`,
  PAID: `Paid`,
  MISSING_ATTRIBUTES: `Missing qualifications`,
  TRANSFER_POSITION: 'Transfer position',
  TRANSFER_LOCATION: 'Transfer location',
  DASHBOARD_TRANSFER_UNAVAILABLE: 'Transfers not available',
  DASHBOARD_TRANSFER_UNAVAILABLE_DESCRIPTION: 'Transfers are only available while you are punched in.',
  DURATION: `Duration`,
  DASHBOARD_BREAK_UNAVAILABLE: 'You cannot currently take a break',
  DASHBOARD_BREAK_UNAVAILABLE_DESCRIPTION: 'Breaks are unavailable before punching in and after punching out',
  BREAKINFO_ON_BREAK: "You're on break",
  BREAKINFO_BREAK_DECLARATION: "You're in your {{name}}.",
  BREAKINFO_RETURN_EXPECTATION: "You're expected to come back at",
  BREAKINFO_BREAK_ENDED: 'Your break ended',
  BREAKINFO_CUSTOM_BREAK_INFO: 'You are on an unplanned break, click the button below when you are done.',
  BREAKINFO_RESUME_WORK_INSTRUCTIONS: 'To resume your work time, click on the button below.',
  BREAKINFO_RESUME_WORK: 'Resume work',
  BREAK_NOT_FOUND: 'Cannot find break',
  INVALID_BREAK: 'Invalid Break',
  CUSTOMBREAK_TITLE: 'Take a break',
  CUSTOMBREAK_REASON_LABEL: "Explain why you're taking a break:",
  CUSTOMBREAK_START_BREAK: 'Start break',
  LOADING_SHIFTS: `Loading shifts`,
  END_UNAVAILABLE: `End time unavailable`,
  CLOSE_PUNCH_TERMINAL: {
    TITLE: `Close punch terminal`,
    SUMMARY: `This will bring you back to the login page. Other users won't be able to access the punch terminal.`,
    BUTTON: `Close punch terminal`,
    CANCEL: `Cancel`,
    CONFIRM: `Confirm`
  },
  punchLocation: {
    LOCATION_SELECTION: {
      TITLE: `Punch location`,
      SUMMARY: `The location will be added to the punch of the employee. This is useful to know which punch terminal are used.`
    },
    LOCATIONID: {
      LABEL: `Location`,
      DESCRIPTION: `Select the location where this punch terminal is located.`
    }
  },
  NO_LOCATIONS: `No locations available. You can still launch the punch terminal.`,
  REQUIRED_FIELD: `This field is mandatory.`,
  END_DATE_REQUIRED_IF_END_TIME: `The end date is required if there is an end time`,
  CANNOT_CREATE_PUNCHCARD_IN_FUTURE: `You cannot create a punch card in the future.`,
  PUNCH_QUESTIONNAIRE_MODAL: {
    TITLE: `Punch questionnaire`,
    SUMMARY: ``,
    NOT_ALLOWED_TO_PUNCH: `Based on your answers to the questionnaire, you are not allowed to punch, please contact your manager.`,
    PLEASE_PUNCH_IN: `Thank you, you may now continue punching in.`,
    EXPLANATION: {
      LABEL: `Explanation`,
      PLACEHOLDER: `Indicate why you are re-submitting the questionnaire and changing your answers.`,
      DESCRIPTION: ``
    },
    EXPLANATION_WARNING: `You previously answered these questions in a way that prevented you from punching.`,
    ANSWER_ALL_QUESTIONS: `Please answer all questions.`
  },
  GREATER_THAN_ZERO: `Must be greater than 0`
}
